import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import Error from "components/form/Error";
import DrawerButton from "components/form/DrawerButton";
import usePartialPayment from "hooks/usePartialPaymentSubmit";

const PartialPaymentDrawer = ({ id, tab }) => {
  const { trigger, register, handleSubmit, onSubmit, errors, loading } =
    usePartialPayment(id, tab);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        <Title register={register} title="Edit Partial Payment" />
      </div>

      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="pt-4 flex-grow scrollbar-hide w-full max-h-full pb-40">
                <div className="grid grid-cols-12 gap-5 mb-6">
                  <div className="col-span-6">
                    <LabelArea label="More than 24 hrs" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="More Than 24 hrs"
                      name="more_than_24"
                      type="number"
                      maxLength={2}
                      placeholder="More Than 24"
                      //  pattern={/^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/}
                    />
                    <Error errorName={errors.more_than_24} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Less than 24 hrs" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Less than 24 hrs"
                      name="less_than_24"
                      type="number"
                      maxLength={2}
                      placeholder="Less Than 24"
                      //  pattern={/^[A-Z]{2}[0-9]{2}[A-Z]{2}[0-9]{4}$/}
                    />
                    <Error errorName={errors.less_than_24} />
                  </div>
                </div>
              </div>

              <DrawerButton
                isSubmitting={loading}
                id={id}
                title={id ? "Update" : "Submit"}
              />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default PartialPaymentDrawer;
